import React, { useState } from "react";
import { openVideoList } from "../../helpers/service";

// Style
import {
  TableWrap,
  TableContent,
  ProfileImage,
  LeftContent,
  ImagesWrap,
  RightContent,
  SeeMoreWrap,
} from "../../style/FavoriteTable";

// Images
import star from "../../images/ic_start.svg";
import emptyState from "../../images/contactLogo.svg";

import { getTeamParamMarkers } from "../../helpers";

// Language
import { useTranslation } from "react-i18next";
import {
  BestPlayerClub,
  BestPlayerContent,
  BestPlayerName,
  BestPlayersTable,
  BestPlayerValue,
  BestPlayerWrap,
  BestPlayerWrapper,
} from "../../style/TournamentsPage";

import { NotificationList } from "../notification/NotificationList";
import { useNotification } from "../notification/useNotification";
import { useParams } from "react-router-dom";
import { useLexicon } from "../../hooks/useLexicon";
import { useParameterLexicon } from "../../hooks/useParameterLexicon";

const BestTeams = ({ table, info }) => {
  const l = useLexicon();
  const { getTeamParameterLexiconId } = useParameterLexicon();
  const { t, i18n } = useTranslation();
  const { id } = useParams();

  const [expandedIndices, setExpandedIndices] = useState([]);

  const toggleShowLeads = (index) => {
    setExpandedIndices((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const { notifications, addNotification, removeNotification } =
    useNotification();

  const getTeamParameterDisplayName = (parameterInput) => {
    const fallbackName =
      typeof parameterInput === "string"
        ? parameterInput
        : parameterInput?.parameter_name || parameterInput?.name || "";
    if (!fallbackName) return '';
    const lexiconId = getTeamParameterLexiconId(parameterInput);
    if (lexiconId) {
      return l(lexiconId) || fallbackName;
    }
    return fallbackName;
  };

  const handleClickPlayerParam = async (param, team) => {
    const { parameter_id: param_id } = param;
    const { team: { id: team_id, name }, value: count } = team;
    try {
      const controller = new AbortController();
      addNotification(`Fetching clips. Please don't close or refresh the page till the download is completed.`, "info", controller);
      document.body.classList.add("loading-cursor");
      const data = await getTeamParamMarkers(
        team_id,
        param_id,
        "in_attack",
        '',
        controller,
        1,
        id
      );
      if (data?.results?.length > 0) {
        const markers = data.results.map((item) => item.id).join(",");
        const displayName = getTeamParameterDisplayName(param);
        openVideoList(markers, `${displayName} - ${name}`);
      } else {
        addNotification(
          `There are 0 clips in the response from the server.`,
          "warning"
        );
      }
    } catch (e) {
      console.log("error get param markers", e);
      if (e.type === "canceled") {
        addNotification(
          `The request to receive ${count} clips of the team has been canceled.`,
          "warning"
        );
        return;
      }
      addNotification(`Error in receiving ${count} team clips.`, "error");
    } finally {
      document.body.classList.remove("loading-cursor");
    }
  };

  const isCanClickPlayerStat = (teams, item) => {
    return (
      item.leaders?.count === 0 ||
      item.parameter_name.includes("%") ||
      item.parameter_name.includes("Mins Played") ||
      item.parameter_name.includes("Clean Sheets")
    );
  };

  const excludeKeywords = [
    "Grave Mistakes",
  ];

  const filteredTable = (table ?? []).filter(
    (item) =>
      !excludeKeywords.some((keyword) =>
        Object.values(item).some(
          (value) => typeof value === "string" && value.includes(keyword)
        )
      )
  );

  return (
    <>
      <BestPlayerWrap>
        {filteredTable.map((item, index) => {
          const displayName = getTeamParameterDisplayName(item);
          return (
            <BestPlayersTable key={index} className="teamCardSize">
              <h2>{displayName}</h2>
              {item.leaders.length > 0 ? (
                <>
                  {item.leaders.slice(0, 5).map((teams, index) => {
                    return (
                      <BestPlayerContent
                        key={index}
                        className="bestTeamContent"
                      >
                        <BestPlayerWrapper>
                          <BestPlayerName
                            href={`/tournaments/team/${teams.team.id}`}
                          >
                            {/* <img src={star} alt={star} /> */}
                            <img
                              src={teams.team.logo ? teams.team.logo : emptyState}
                              alt={teams.team.logo ? teams.team.logo : emptyState}
                              className="profileImage"
                            />
                            <h5>{teams.team.name}</h5>
                          </BestPlayerName>
                          <BestPlayerValue>
                            <h5
                              style={
                                isCanClickPlayerStat(teams, item)
                                  ? { cursor: "not-allowed" }
                                  : { cursor: "pointer" }
                              }
                              onClick={() =>
                                !isCanClickPlayerStat(teams, item) &&
                                handleClickPlayerParam(item, teams)
                              }
                              onContextMenu={e => {
                                e.preventDefault()
                                !isCanClickPlayerStat(teams, item) &&
                                  handleClickPlayerParam(item, teams)
                              }}
                            >
                              {teams.value}
                            </h5>
                          </BestPlayerValue>
                        </BestPlayerWrapper>
                      </BestPlayerContent>
                    );
                  })}
                  {item?.leaders?.length > 5 && (
                    <>
                      {expandedIndices.includes(index)
                        ? item?.leaders?.slice(5)?.map((teams, index) => (
                          <BestPlayerContent
                            key={index}
                            className="bestTeamContent"
                          >
                            <BestPlayerWrapper>
                              <BestPlayerName
                                href={`/tournaments/team/${teams.team.id}`}
                              >
                                {/* <img src={star} alt={star} /> */}
                                <img
                                  src={teams.team.logo ? teams.team.logo : emptyState}
                                  alt={teams.team.logo ? teams.team.logo : emptyState}
                                  className="profileImage"
                                />
                                <h5>{teams.team.name}</h5>
                              </BestPlayerName>
                              <BestPlayerValue>
                                <h5
                                  style={
                                    isCanClickPlayerStat(teams, item)
                                      ? { cursor: "not-allowed" }
                                      : { cursor: "pointer" }
                                  }
                                  onClick={() =>
                                    !isCanClickPlayerStat(teams, item) &&
                                    handleClickPlayerParam(item, teams)
                                  }
                                  onContextMenu={e => {
                                    e.preventDefault()
                                    !isCanClickPlayerStat(teams, item) &&
                                      handleClickPlayerParam(item, teams)
                                  }}
                                >
                                  {teams.value}
                                </h5>
                              </BestPlayerValue>
                            </BestPlayerWrapper>
                          </BestPlayerContent>
                        ))
                        : null}
                      <button onClick={() => toggleShowLeads(index)}>
                        {expandedIndices.includes(index)
                          ? l(1013)
                          : l(1012)}
                      </button>
                    </>
                  )}
                </>
              ) : (
                <h2>{l(464)}</h2>
              )}
            </BestPlayersTable>
          );
        })}
      </BestPlayerWrap>

      {/* display notifications */}
      <NotificationList
        notifications={notifications}
        onClose={removeNotification}
      />
    </>
  );
};

export default BestTeams;
